import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { observer } from "mobx-react";
import { ParentContainer, MainContainer, ContentContainer, HeaderContainer, ScreenTitle, SupportingText, ButtonContainer, FooterText, } from "./DocumentRetrievalRecordsShared.styles";
import { FlexColumn } from "./common.styles";
export const PatientConsentPDDEGDUBaseAnimatingComponent = observer((props) => {
    const shouldAnimate = props.animate !== false;
    const [isAnimating, setIsAnimating] = React.useState(shouldAnimate);
    React.useEffect(() => {
        if (!shouldAnimate) {
            setIsAnimating(false);
            return undefined;
        }
        const timer = setTimeout(() => {
            setIsAnimating(false);
        }, 400);
        return () => clearTimeout(timer);
    }, [shouldAnimate]);
    return (_jsxs(ParentContainer, { children: [_jsx(MainContainer, { isAnimating: isAnimating, animate: shouldAnimate, children: _jsxs(ContentContainer, { children: [_jsxs(HeaderContainer, { children: [props.logoComponent, _jsxs(FlexColumn, { gap: 16, alignItems: "center", children: [_jsx(ScreenTitle, { children: props.title }), _jsx(SupportingText, { isAnimating: shouldAnimate ? isAnimating : undefined, animate: shouldAnimate, children: props.supportingText })] })] }), typeof props.children === "function" ? props.children(isAnimating) : props.children] }) }), props.buttons !== null && (_jsxs(ButtonContainer, { isAnimating: isAnimating, animate: shouldAnimate, children: [props.footerText !== undefined && _jsx(FooterText, { children: props.footerText }), props.buttons] }))] }));
});
